// extracted by mini-css-extract-plugin
var _1 = "UserItem_email__4GWlC";
var _2 = "UserItem_menuItem__lin5F";
var _3 = "UserItem_menuItemText__5jLX0";
var _4 = "UserItem_name__eEqh7";
var _5 = "UserItem_username__YZ41M";
export { _1 as "email", _2 as "menuItem", _3 as "menuItemText", _4 as "name", _5 as "username" }
